import { ResponsiveBar } from '@nivo/bar'
// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
export const PackageChart = ({ packages, name }) => {
  const data = packages.reduce(
    (ret, v) => {
      if (v.type) {
        ret[v.type] = v.count
      }
      return ret
    },
    { name: name }
  )
  const keys = packages.map((v) => v.type)
  return (
    <ResponsiveBar
      data={[data]}
      keys={keys}
      margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
      padding={0.3}
      indexBy="name"
      layout="horizontal"
      colors={{ scheme: 'nivo' }}
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={null}
      enableGridY={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      legends={[]}
      animate={false}
      motionStiffness={90}
      motionDamping={15}
    />
  )
}
